'use strict';

angular.module('shiftTraderApp')
  .directive('saStackedStars', function () {
    return {
      template: '<div class=\"sa-stacked-stars\"></div>',
      restrict: 'EA',
      scope: {
        numStars: '=',
        showAllStars: '@'
      },
      link: function postLink(scope, element) {
        if (scope.showAllStars === 'true') {
          element.find('div').append('<i class=\"icon-star-circle\"></i>');
        }

        scope.$watch('numStars', function() {
          var x = parseInt(scope.numStars);

          if (scope.showAllStars !== 'true') {
            element.find('i.icon-star').remove();

            if (x > 0) {
              _.forEach(_.range(x), function() {
                element.find('div').append('<i class=\"icon-star\"></i>');
              });
            }
          }

          _.each(['nostars','onestar','twostars','threestars'], function(cls) {
            element.removeClass(cls);
          });

          switch(x) {
            case 0:
              element.addClass('nostars');
              break;
            case 1:
              element.addClass('onestar');
              break;
            case 2:
              element.addClass('twostars');
              break;
            case 3:
              element.addClass('threestars');
              break;
            default:
              break;
          }
        });
      }
    };
  });
